export const ROUTES = {
  ATS_INTEGRATIONS: '/ats-integrations',
  CUSTOM_ATS_INTEGRATION: '/ats-integrations/custom-integration',
  GET_MERGE_FRONTEND_LINK_TOKEN: '/ats-integrations/frontend-link-token',
  GET_ATS_ACCOUNT_JOBS: '/ats-integrations/jobs',
  GET_ATS_LOGIN_URL: '/ats-integrations/login-url',
};

export const REDUCER_PATH = 'atsIntegrationApi';
